import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function fmtErr(e, fallback = "Something went wrong. Please try again.") {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || "").filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return e?.message || fallback;
}

export const SHOP = {
  name: "Appleman Tech Repair",
  address: "24 Springwell Gardens, Hyde, Tameside SK14 3QL",
  phone: "07934 967659",
  phoneHref: "tel:+447934967659",
  whatsapp: "https://wa.me/447830863054",
  whatsappDisplay: "07830 863054",
  hours: [
    { day: "Monday", time: "10:30am – 6:00pm" },
    { day: "Tuesday", time: "10:30am – 6:00pm" },
    { day: "Wednesday", time: "10:30am – 6:00pm" },
    { day: "Thursday", time: "10:30am – 6:00pm" },
    { day: "Friday", time: "10:30am – 6:00pm" },
    { day: "Saturday", time: "Closed" },
    { day: "Sunday", time: "Closed" },
  ],
};
